import { IImageBaseViewModel } from 'Types/Litium';
import { dpr } from 'Utils/dpr';
import { getNewDimensionsWithAspectRatio } from 'Utils/getNewDimensionsWithAspectRatio';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

const ImageStripe = ({
    imageStripe,
    className = '',
}: {
    imageStripe: IImageBaseViewModel;
    className?: string;
}) =>
    imageStripe?.src && (
        <figure className={`-:w-full ${className}`}>
            <picture className="h-full w-full">
                <source
                    width={parseInt(tailwindBreakpoints.xxxl)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.xxxl),
                        'height'
                    )}
                    media={`(min-width: ${tailwindBreakpoints.xxxl})`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.xxxl
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.xxxl),
                            'height'
                        )}`
                    )}
                />
                <source
                    width={parseInt(tailwindBreakpoints.xxl)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.xxl),
                        'height'
                    )}
                    media={`(min-width: ${tailwindBreakpoints.xxl})`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.xxl
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.xxl),
                            'height'
                        )}`
                    )}
                />
                <source
                    width={parseInt(tailwindBreakpoints.xl)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.xl),
                        'height'
                    )}
                    media={`(min-width: ${tailwindBreakpoints.xl})`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.xl
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.xl),
                            'height'
                        )}`
                    )}
                />
                <source
                    width={parseInt(tailwindBreakpoints.lg)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.lg),
                        'height'
                    )}
                    media={`(min-width: ${tailwindBreakpoints.lg})`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.lg
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.lg),
                            'height'
                        )}`
                    )}
                />
                <source
                    width={parseInt(tailwindBreakpoints.md)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.md),
                        'height'
                    )}
                    media={`(min-width: ${tailwindBreakpoints.md})`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.md
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.md),
                            'height'
                        )}`
                    )}
                />
                <img
                    className="h-auto w-full"
                    src={`${imageStripe.src}?format=webp&width=${parseInt(
                        tailwindBreakpoints.sm
                    )}&height=${getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.sm),
                        'height'
                    )}`}
                    srcSet={dpr(
                        `${imageStripe.src}?format=webp&width=${parseInt(
                            tailwindBreakpoints.sm
                        )}&height=${getNewDimensionsWithAspectRatio(
                            imageStripe.width,
                            imageStripe.height,
                            parseInt(tailwindBreakpoints.sm),
                            'height'
                        )}`
                    )}
                    width={parseInt(tailwindBreakpoints.sm)}
                    height={getNewDimensionsWithAspectRatio(
                        imageStripe.width,
                        imageStripe.height,
                        parseInt(tailwindBreakpoints.sm),
                        'height'
                    )}
                    alt={imageStripe.altText}
                />
            </picture>
        </figure>
    );

export default ImageStripe;
